// extracted by mini-css-extract-plugin
export default {"divHomeBanner":"homeBanner_divHomeBanner__-kLYS","image":"homeBanner_image__1pCbP","divTypography":"homeBanner_divTypography__GkHA4","typography":"homeBanner_typography__Ly6Z6"};